import moment from 'moment';
import { stringify } from 'query-string';
import { HALF_YEAR_DAYS } from 'cityads-v3/utils/dateUtils';
import { makeRequest, SADUKA_TRANSPORT_PREFIX } from 'cityads-v3/utils/apiUtils';

export const GET_NEWS_TYPES = 'news/GET_NEWS_TYPES';
export const GET_NEWS_TYPES_SUCCESS = 'news/GET_NEWS_TYPES_SUCCESS';
export const GET_NEWS_TYPES_FAIL = 'news/GET_NEWS_TYPES_FAIL';

export const GET_NEWS = 'news/GET_NEWS';
export const GET_NEWS_SUCCESS = 'news/GET_NEWS_SUCCESS';
export const GET_NEWS_FAIL = 'news/GET_NEWS_FAIL';

export const GET_NEWS_BY_ID = 'news/GET_NEWS_BY_ID';
export const GET_NEWS_BY_ID_SUCCESS = 'news/GET_NEWS_BY_ID_SUCCESS';
export const GET_NEWS_BY_ID_FAIL = 'news/GET_NEWS_BY_ID_FAIL';

export const GET_OFFER_NEWS = 'news/GET_OFFER_NEWS';
export const GET_OFFER_NEWS_SUCCESS = 'news/GET_OFFER_NEWS_SUCCESS';
export const GET_OFFER_NEWS_FAIL = 'news/GET_OFFER_NEWS_FAIL';

export function getNewsTypes() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/newsTypes`, {
    types: [GET_NEWS_TYPES, GET_NEWS_TYPES_SUCCESS, GET_NEWS_TYPES_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getNews(newsTypes, {
  loadMore = false,
  page = 1
} = {}) {
  const queryStr = newsTypes ?
    '&' + newsTypes.map(type => `type_id[]=${encodeURIComponent(type)}`).join('&') :
    '';

  return makeRequest('/saduka/news?page=' + page + '&sort=date_publish&sort_asc=false&for_feed=true' + queryStr, {
    types: [GET_NEWS, GET_NEWS_SUCCESS, GET_NEWS_FAIL],
    options: {
      credentials: 'include'
    },
    newsTypes,
    loadMore,
    page,
  });
}

export function getOfferNews(offerId) {
  const params = {
    offer_id: offerId,
    date_publish_from: moment().subtract(HALF_YEAR_DAYS - 1, 'day').format('YYYY-MM-DD'),
    sort: 'date_publish',
    sort_asc: false,
    perpage: 5
  };

  return makeRequest(`/saduka/news?${stringify(params, {arrayFormat: 'bracket'})}`, {
    types: [GET_OFFER_NEWS, GET_OFFER_NEWS_SUCCESS, GET_OFFER_NEWS_FAIL],
    options: {
      credentials: 'include'
    },
    offerId,
  });
}

export function getNewsById(id) {
  return makeRequest('/saduka/news/' + id, {
    types: [GET_NEWS_BY_ID, GET_NEWS_BY_ID_SUCCESS, GET_NEWS_BY_ID_FAIL],
    options: {
      credentials: 'include'
    }
  })
}
